import { gql } from '@apollo/client';
import {
  SlackConnectionFieldsFragment,
  SlackDestinationEntitiesFieldsFragment,
} from './fragments';

export const GET_SLACK_DESTINATION_ENTITIES = gql`
  query GetSlackDestinationEntities($term: String!, $channelLimit: Int!) {
    slackDestinationEntities(term: $term, channelLimit: $channelLimit) {
      ...SlackDestinationEntitiesFields
    }
  }
  ${SlackDestinationEntitiesFieldsFragment}
`;

export const GET_SLACK_CONNECTION = gql`
  query GetSlackConnection($input: SlackSourceInput!) {
    slackConnection(input: $input) {
      ...SlackConnectionFields
    }
  }
  ${SlackConnectionFieldsFragment}
`;
